module.exports = {
    googleLibraries:['places']
}